module.exports = __webpack_public_path__ + "img/wave-mid.cf5334d0.png";